import React from 'react'
import styled from '@emotion/styled'
import Triangle from './ExclamationTriangle'
import { fontSize2XSmall, redLight10, fontWeightSemibold, fontFamilyOpenSans } from '../../constants/principles'

export default ({ text, id, testId, isError, leftAlign, children, margin, topError = false }) => (
  <>
    <StyledError id={id} data-testid={testId} isError={isError} leftAlign={leftAlign} margin={margin} topError={topError}>
      <SpacedSpan topError={topError}>
        <Triangle colorFill={redLight10} width={16} hieght={16} />
      </SpacedSpan>
      {text}
    </StyledError>
    {children}
  </>
)
const SpacedSpan = styled.span`
  height: 16px;
  padding-right: 8px;
  margin-top: 4px;
  ${p => p.topError && `margin-bottom: 4px;`}
`
const StyledError = styled.p`
  font-size: ${fontSize2XSmall};
  font-weight: ${fontWeightSemibold};
  font-family: ${fontFamilyOpenSans};
  color: ${redLight10};
  display: ${p => (p.isError ? 'flex' : 'none')};
  justify-content: ${p => (p.leftAlign ? 'flex-start' : 'center')};
  text-align: ${p => (p.leftAlign ? 'left' : 'center')};
  margin: ${p => (p.margin ? p.margin : '8px 0')};
  ${p => p.topError && `flex-direction: column;`}
`
